import { EnvironmentState, initialState } from './environment.state';
import { createReducer, on } from '@ngrx/store';
import { environmentLoadedFailure, environmentLoadedSuccess } from './environment.actions';

const reducer = createReducer(
	initialState,
	on(environmentLoadedSuccess, (state, action) => ({ loaded: true, ...action.payload })),
	on(environmentLoadedFailure, () => ({ ...initialState }))
);

export function environmentReducer(state, action): EnvironmentState {
	return reducer(state, action);
}
